module.exports = __webpack_public_path__ + "static/media/add certificate.1ac18d69.svg";